<template>
<div class="express-list">
    <!--头部选择区-->
    <!-- <tab-card :items="navList" :height="88" @tabClicked="tabClicked" :selectIndex="selectIndex"></tab-card> -->
    <van-tabs v-model="selectIndex" @click="tabClicked" :line-width="50">
        <van-tab v-for="(item, index) in navList" :key="index" :title="item.text" :name="index">
            <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                <!--快递单号-->
                <div class="yudan-number">
                    <span>{{logisticsCompany}}：{{logisticsCode}}</span>
                    <img src="../assets/img/common/copy@2x.png" class="clip-icon"
                    v-clipboard:copy="logisticsCode"
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onError">
                </div>
                <!--快递详细信息区域-->
                <!-- 纵向排列 -->
                <div class="step-list">
                    <van-steps direction="vertical" :active="activeCount"
                    >
                        <van-step v-for="(item, index) in stepInfoList" :key="index">
                            <h3>{{item.title}}</h3>
                            <p>{{item.desc}}</p>
                        </van-step>
                    </van-steps>
                </div>
            </van-pull-refresh>
        </van-tab>
    </van-tabs>
</div>
</template>

<script>
import {
    toastLoading,
    clearToastLoading
} from '@/utils/base/utils';
import { Toast } from 'vant';
export default {
    data() {
        return {
            selectIndex: 0,
            navList: [],
            stepInfoList: [],
            logisticsCompany: '',
            logisticsCode: '',
            activeCount: 1,
            isLoading: false
        };
    },
    esvReady() {

    },
    esvShow() {
        this.orderCode = this.$route.params.orderCode;
        this.queryLogisticsTranceList();
    },
    methods: {
        queryLogisticsTranceList(callback) {
            const ths = this;
            this.$doRequest({
                url: '/logistics/queryLogisticsTranceList',
                params: {
                    orderCode: ths.orderCode
                },
                before: function () {
                    ths.loading = toastLoading();
                },
                complete: function () {
                    clearToastLoading(ths.loading);
                    callback && callback();
                }
            }, (data) => {
                const len = data.result.length;
                this.navList = [];
                for (let i = 1; i <= len; i++) {
                    this.navList.push({
                        text: '物流' + i
                    });
                }
                this.logisticsData = data.result;
                const res = this.logisticsData[0];
                this.handlerProcessData(res);
            });
        },
        handlerProcessData(res) {
            this.logisticsCompany = res.logisticsCompany;
            this.logisticsCode = res.logisticsCode;
            this.stepInfoList = [];
            this.stepInfoList.push({
                title: `[收货地址] ${res.receiverAddress}`,
                desc: res.createTime
            });
            res.tracesResponseList.forEach((item) => {
                this.stepInfoList.push({
                    title: item.acceptStation,
                    desc: item.acceptTime
                });
            });
            this.activeCount = res.tracesResponseList.length;
        },
        tabClicked(name) {
            this.selectIndex = name;
            const res = this.logisticsData[this.selectIndex];
            this.handlerProcessData(res);
        },
        // 复制
        onCopy() {
            Toast('复制成功');
        },
        onError() {

        },
        // 下拉刷新
        onRefresh() {
            this.queryLogisticsTranceList(() => {
                this.isLoading = false;
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.yudan-number {
    margin-top: 12px;
    height: 50px;
    line-height: 50px;
    background: #ffffff;
    color: #414141;
    font-size: 14px;
    padding: 0 12px;
    margin-bottom: 12px;

    .clip-icon {
        height: 12px;
        width: 11px;
        margin-left: 13px;
    }
}

.step-list {
    background: #FFFFFF;
    margin-top: 12px;
    .van-steps {
        background: #fff;
    }
}
</style>
